const PlanRecommenderResultsSender = () => {
  return <div className="div"></div>;
};

export default PlanRecommenderResultsSender;
